var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../utils/mobx/decorators/memoize';
import { AskingMedia } from './modules/AskingMedia';
import { AskingProgress } from './modules/AskingProgress';
import { AskingMarks } from './modules/AskingMarks';
import { AskingMemory } from './modules/AskingMemory';
export class Asking {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get app() {
        return this.parent;
    }
    get askingProgress() {
        return new AskingProgress(this);
    }
    get askingMedia() {
        return new AskingMedia(this);
    }
    get askingMarks() {
        return new AskingMarks(this);
    }
    get askingMemory() {
        return new AskingMemory(this);
    }
}
__decorate([
    memoize
], Asking.prototype, "askingProgress", null);
__decorate([
    memoize
], Asking.prototype, "askingMedia", null);
__decorate([
    memoize
], Asking.prototype, "askingMarks", null);
__decorate([
    memoize
], Asking.prototype, "askingMemory", null);
